
import {View} from 'backbone';
import template from 'common-views/simple-confirm.ejs';
import constants from 'Constants.js';
import $ from 'jquery';

class SimpleConfirmModalView extends View {
    initialize(opts){
        super.initialize(opts);
        if (!this.model.get('subtitle')) {
            this.model.set('subtitle',  'Confirmation Dialog');
        }

        if (!this.model.get('width')) {
            this.model.set('width',  500);
        }

        if (this.model.get('showCancel') === undefined) {
            this.model.set('showCancel', true);
        }

        $('body').append(this.$el);
    }

    render() {

        let dialog = $('#dialog');
        if (dialog) {
            dialog.remove();
        }

        let _self = this;

        return new Promise((resolve, reject) => {             

            this.$el.html(template(this.model.toJSON()));
            this.delegateEvents();
            var self = this; 

            let buttons = [
                {
                    text: 'OK',
                    'class':'btn-select-item',
                    click: function() { 
                        resolve('Ok');
                        _self.closeModal();
                    }
                }];
                
            if (this.model.get('showCancel')) {
                buttons.push({'text': 'Cancel',
                                    click: function() { 
                                        resolve('Cancel');
                                        _self.closeModal();
                                    }
                            });
            }

            $( constants.DIALOG_ID ).dialog({
                dialogClass: "no-close",
                autoOpen: true,
                height: this.model.get('height') || 'auto',
                width: this.model.get('width'),
                modal: true,
                resizable: false,
                buttons: buttons,
                close: function( event, ui ) {                    
                    _self.closeModal();       
                }
            });

            $('div[role="dialog"]').draggable({containment: 'body', scroll: false});
        });
    }

    closeModal() {
        let dialog = $( constants.DIALOG_ID );
        dialog.dialog( "close" );
        dialog.remove();
    }
}

export default SimpleConfirmModalView;